import * as React from "react";
import { SearchableComboBox } from "src/components/base/SearchableComboBox";
import { flowstepUIControl } from "@v2/types/data";
import useDataLoader from "@v2/utils/useDataLoader";
import { DataObject } from 'shared/providers/types';
import { useEffect, useRef, useState } from "react";

interface Props extends flowstepUIControl<DataObject[], DataObject> {
  errorMessage?: string;
  placeholder?: string;
  onSearch?: (query: string) => void;
  immediateSearch?: boolean;
}

const ObjectPicker: React.FC<Props> = (props) => {
  const { value, onChange, data, disabled, errorMessage, placeholder, onSearch, immediateSearch } = props;

  const dataObjects = useDataLoader<DataObject[]>(data) || [];

  const objectsOptions = React.useMemo(() =>
    dataObjects.map(item => ({ ...item, key: item.id || item.name, text: item.label })), [dataObjects]
  );

  const [query, setQuery] = useState('');
  const timeoutRef = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    onSearch?.(query);
    return () => { timeoutRef.current && clearTimeout(timeoutRef.current); }
  }, [query])

  const handleSearch = (query: string) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => setQuery(query), 500);
  }

  return (
    <div>
      <SearchableComboBox
        placeholder={placeholder || 'Select object'}
        selectedKey={value?.id || value?.name}
        options={objectsOptions}
        onChange={(_, item) => onChange(true, item as DataObject)}
        disabled={disabled}
        errorMessage={errorMessage}
        instanceSearch={immediateSearch}
        onSearch={(query) => handleSearch(query)}
      />
    </div>
  );
};

export default ObjectPicker;
